import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { ITableModel } from '../table/model/tableModel';
import { Helpers } from '../../../helpers';
import { Router } from '@angular/router';
import { appService } from '../../../_services/app.service';
import { ToastrService } from 'ngx-toastr';
import { CookieService } from 'ngx-cookie-service';
import { DecryptPipe } from '../../../auth/_services/encrypt-decrypt.pipe';
import { CommonService } from '../../../_services/common.service';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-shipment-transactions',
  templateUrl: './shipment-transactions.component.html',
  styleUrls: ['./shipment-transactions.component.scss']
})
export class ShipmentTransactionsComponent implements OnInit {

  static that: ShipmentTransactionsComponent;
  tableDetails: ITableModel;
  totalCount: number = 0;
  noOfPages: number = 15;
  searchValue: string = '';
  filterObj: any = {
    Status: 'All'
  };
  payload: any = {};
  @Input() Id: any;
  @Input() referenceType: any;
  @Input() headerName: any;

  @Input() shipmentModetypearray: any = [];
  @Input() parentTypearray: any = [];

  data: any = {};
  reportHeader: any = [];
  TenantId: any;
  CompanyId: any;
  userId: any;

  FromDate: any = {
    formControlName: 'FromDate',
    dataField: 'FromDate',
    placeholder: 'Select FromDate'
  };
  ToDate: any = {
    formControlName: 'ToDate',
    dataField: 'ToDate',
    placeholder: 'Select ToDate'
  };
  searchFieldDetails: any = {
    placeholder: "Search",
    type: "text",
    isSearchBox: true,
  };
  constructor(
    private router: Router,
    private _appService: appService,
    private toastr: ToastrService,
    private cookieService: CookieService,
    private decryptpipe: DecryptPipe,
    private commonService: CommonService,
    private datePipe: DatePipe,
  ) {
    ShipmentTransactionsComponent.that = this;
  }

  ngOnInit() {
    this.TenantId = JSON.parse(
      this.decryptpipe.transform(JSON.parse(this.cookieService.get("TenantId"))));
    const ChnageCompnayId = JSON.parse(localStorage.getItem("ChnageCompnayId"));
    this.CompanyId = ChnageCompnayId && ChnageCompnayId.Id;
    this.userId = this.decryptpipe.transform(JSON.parse(this.cookieService.get("UserId")));
    const storedPerPage = localStorage.getItem('perPage');
    if (storedPerPage) {
      this.noOfPages = parseInt(storedPerPage, 10);
    }
    const currentDate = new Date();
    const firstDateOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);


    this.data[this.ToDate.dataField] = this.datePipe.transform(new Date(), 'dd-MMM-yyyy');
    this.data[this.FromDate.dataField] = this.datePipe.transform(firstDateOfMonth, 'dd-MMM-yyyy');

    this.initalizeForm();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['Id']) {
      this.Id = changes['Id'].currentValue;
      if (changes['shipmentModetypearray']) {
        this.shipmentModetypearray = changes['shipmentModetypearray'].currentValue;
      }
      if (changes['parentTypearray']) {
        this.parentTypearray = changes['parentTypearray'].currentValue;
      }
      //   if (this.Id) {
      //     this.GetTransactionList('', 0, {}, this.noOfPages, this.Id)
      //   }
    }
  }

  async initalizeForm() {
    this.tableDetails = {
      emptyDataMSg: "No Records Found.",
      isColumnNameShow: true,
      data: [],
      columnDetails: [
        { columnName: 'order_LTL.OrderNo', dataFieldName: 'OrderNo', dataFieldName2: 'OrderDate', dataFieldName3: 'ReferenceNo', color: 'var(--colors-primary-blue-blue-200, #3367FB)' },
        { columnName: 'order_LTL.Status', dataFieldName: 'OrderTripStatus', divType: 'ftlstatus' },
        { columnName: "order_LTL.Customer", dataFieldName: "CustomerName" },
        { columnName: 'order_LTL.CargoDetails', dataFieldName: 'QtyWeight', color: 'var(--colors-primary-blue-blue-200, #3367FB)' },
        { columnName: 'order_LTL.Origin', dataFieldName: 'PickupLocationCode', dataFieldName2: 'PickupPincode', dataFieldName3: 'PickupDate' },
        { columnName: 'order_LTL.Destination', dataFieldName: 'DeliveryLocationCode', dataFieldName2: 'DeliveryPincode', dataFieldName3: 'DeliviryDate' },
        { columnName: 'order_LTL.TripDetails', dataFieldName: 'TripNo', dataFieldName2: 'Transporter', dataFieldName3: 'VehicleNo', dataFieldName4: 'Driver' },
        { columnName: 'order_LTL.InvoiceNo', dataFieldName: 'InvoiceNo', dataFieldName2: 'InvoiceDate', columnName3: 'EInvoice Done', dataFieldName3: 'IsEInvoiceGenerate' },
        { columnName: 'order_LTL.EWayBillNo', dataFieldName: 'eWayBillNo', dataFieldName2: 'eWayBillExpiryDate' },
      ],

    }
  }

  getChangedValue(value, data) {
    if (data.dataField == 'FromDate') {
      if (value != null) {
        this.data[this.FromDate.dataField] = value;
      }
    }
    if (data.dataField == 'ToDate') {
      if (value != null) {
        this.data[this.ToDate.dataField] = value;
      }
    }
  }

  GetTransactionList(
    searchValue = this.searchValue,
    pageNo: number = 0,
    filterObject: any = this.filterObj,
    perPage: any = this.noOfPages,
    Id,
    CompanyId
  ) {

    Helpers.setLoading(true);

    if (CompanyId !== undefined && CompanyId !== null) {
      this.CompanyId = CompanyId;
    }

    this.payload.Start = pageNo * perPage;
    this.payload.PerPage = perPage;
    this.payload.SearchValue = searchValue || null;
    this.payload.userId = this.userId;
    this.payload.CompanyId = (CompanyId !== undefined && CompanyId !== null) ? CompanyId : this.CompanyId;

    if (this.parentTypearray.includes('customer') || this.shipmentModetypearray.includes('modern trade') || this.parentTypearray.includes('manufacturer') || this.shipmentModetypearray.includes('customer') || this.shipmentModetypearray.includes('general trade')) {
      this.payload.CustomerName = Id ? Id : this.Id;
    } else {
      this.payload.CustomerName = null;
    }

    this.payload.ShipTo = null;
    this.payload.FromDate = this.data.FromDate || null;
    this.payload.ToDate = this.data.ToDate || null;
    this.payload.Status = 'All';
    if (this.parentTypearray.includes('vendor') || this.parentTypearray.includes('transporter') || this.shipmentModetypearray.includes('road freight') || this.shipmentModetypearray.includes('road transporters')) {
      this.payload.transporterId = Id ? Id : this.Id;
    } else {
      this.payload.transporterId = null;
    }

    if (this.referenceType == 'Driver') {
      this.payload.DriverId = Id ? Id : this.Id;
    } else {
      this.payload.DriverId = null;
    }

    if (this.referenceType == 'Vehicles') {
      this.payload.VehicleId = Id ? Id : this.Id;
    } else {
      this.payload.VehicleId = null;
    }

    this.payload.tabId = Id ? Id : this.Id;
    this.payload.tabreferenceType = this.referenceType;

    this._appService.Post("Order_LTL", "ol_orderLTLGetList", this.payload).subscribe((response) => {
      if (response.length) {
        this.totalCount = response[0].recordcount;
        // this.EwayBillDocURL = response[0].EwayBillDocURL;
        // this.isListApiCalled = true;
      }
      this.assignTableFields(pageNo, perPage, response);
      // this.selectedProductData = { totalQty: 0, totalWeight: 0 };
      Helpers.setLoading(false);
    },
      (err) => {
        Helpers.setLoading(false);
        this.toastr.error("Error while fetching data", err);
      }
    );
  }

  assignTableFields(pageNo, perPage, data) {
    this.tableDetails = {
      ...this.tableDetails, paginationDetails: {
        totalItems: this.totalCount,
        itemsPerPage: perPage,
        currentPage: pageNo + 1
      },
      data: data,
    }
  }

  onPageChange(pageNo: number) {
    this.GetTransactionList('', pageNo - 1, {}, this.noOfPages, this.Id, this.CompanyId);
  }

  onPageNumberChange(noOfPages: any) {
    this.noOfPages = noOfPages;
    this.GetTransactionList("", 0, {}, noOfPages, this.Id, this.CompanyId);
  }

  GetTransactionListDownload(
    searchValue = this.searchValue,
    pageNo: number = 0,
    filterObject: any = this.filterObj,
    perPage: any = this.noOfPages,
    Id
  ) {

    Helpers.setLoading(true);

    this.payload.Start = pageNo * perPage;
    this.payload.PerPage = perPage;
    this.payload.SearchValue = searchValue || null;
    this.payload.userId = this.userId;
    this.payload.CompanyId = this.CompanyId;

    if (this.parentTypearray.includes('customer') || this.shipmentModetypearray.includes('modern trade') || this.parentTypearray.includes('manufacturer') || this.shipmentModetypearray.includes('customer') || this.shipmentModetypearray.includes('general trade')) {
      this.payload.CustomerName = Id ? Id : this.Id;
    } else {
      this.payload.CustomerName = null;
    }

    this.payload.ShipTo = null;
    this.payload.FromDate = this.data.FromDate || null;
    this.payload.ToDate = this.data.ToDate || null;
    this.payload.Status = 'All';
    if (this.parentTypearray.includes('vendor') || this.parentTypearray.includes('transporter') || this.shipmentModetypearray.includes('road freight') || this.shipmentModetypearray.includes('road transporters')) {
      this.payload.transporterId = Id ? Id : this.Id;
    } else {
      this.payload.transporterId = null;
    }

    if (this.referenceType == 'Driver') {
      this.payload.DriverId = Id ? Id : this.Id;
    } else {
      this.payload.DriverId = null;
    }

    this.payload.tabid = Id ? Id : this.Id;
    this.payload.referenceType = this.referenceType;

    this._appService.Post("Order_LTL", "ol_orderLTLGetListDownload", this.payload).subscribe((response) => {
      this.DownloadFile(response);
      Helpers.setLoading(false);
    },
      (error) => {
        Helpers.setLoading(false);
        this.toastr.error("Error while downloading", error);
      }
    );
  }

  DownloadFile(FileContent) {
    var byteNumbers = new Array(FileContent.Content.length);
    for (var i = 0; i < FileContent.Content.length; i++) {
      byteNumbers[i] = FileContent.Content.charCodeAt(i);
    }
    var blob = this.commonService.b64toBlob(FileContent.Content, FileContent.ContentType);
    let url = window.URL.createObjectURL(blob);
    $("#DownLoadFileTyreReport").attr('href', url);
    $("#DownLoadFileTyreReport").attr('download', FileContent.FileName);
    let element: HTMLElement = document.getElementById("DownLoadFileTyreReport") as HTMLElement;
    element.attributes
    element.click();
  }

}
